// extracted by mini-css-extract-plugin
module.exports = {"container":"lWwzGND0","isButton":"eO7Vvf8m","messageContainer":"PW23b_mw","title":"J9MDfXfG","message":"mXyPf1ZC","iconContainer":"Ww2ttjOa"};